<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";
import Hero from "@/components/media/Hero.vue";

export default {
  name: "JobsList",
  data() {
    return {
      componentId: null,
    };
  },
  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  mounted() {
 
  },
  methods: {
 
  },
  components: {
    Jobs,
    SearchJob,
    Hero
  },
};
</script>

<template>
  <div>
     <Hero
        position="relative"
        :search="true"
         :image="'banner-hero-1.jpg'"
        height="85vh"
      />

    <div class="marge-hero"></div>
    <Jobs />
  </div>
</template>

